import { useState, useEffect, useCallback } from 'react';
import { SociogramApi } from '@BUP/services/Axios';

export function useGetDashboardResponses(sociogram) {
  const [listState, setListState] = useState({
    data: [],
    organizationResults: [],
    isLoading: true,
    error: null,
  });

  // const sociogramSurveys = sociogram?.surveys.map((survey) => {
  //   return survey.id;
  // });

  const getDashboardResults = useCallback(async () => {
    setListState((prevState) => ({
      ...prevState,
      isLoading: true,
    }));
    try {
      const { data } = await SociogramApi.get('/results');

      const organizationResults = data?.filter(
        (elem) =>
          parseInt(elem?.survey?.sociogram_id, 10) ===
          parseInt(sociogram?.id, 10)
      );

      setListState((prevState) => ({
        ...prevState,
        data,
        organizationResults,
        isLoading: false,
      }));
    } catch (error) {
      setListState((prevState) => ({
        ...prevState,
        error: {
          message:
            'Ocurrió un error inesperado, por favor vuelve a intentarlo.',
        },
        data: [],
      }));
    } finally {
      setListState((prevState) => ({
        ...prevState,
        isLoading: false,
        error: null,
      }));
    }
  }, [setListState, sociogram]);

  useEffect(() => {
    getDashboardResults();
  }, [sociogram]);

  return {
    data: listState.data,
    organizationResults: listState.organizationResults,
    isLoading: listState.isLoading,
    error: listState.error,
  };
}
